const MUTATION_SET_USER = 'SET_USER'
const MUTATION_SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED'
const MUTATION_SET_USER_TOKEN = 'SET_USER_TOKEN'
const MUTATION_SET_NOTIFICATION = 'SET_NOTIFICATION'

const MUTATION_SET_COURSES = 'SET_MASTER_COURSES'
const MUTATION_SET_APPLICATIONS = 'SET_MASTER_COURSE_APPLICATIONS'
const MUTATION_SET_APPROVE = 'SET_MASTER_COURSE_APPROVE'
const MUTATION_SET_REJECT = 'SET_MASTER_COURSE_REJECT'

const MUTATION_SET_METRICS_PERIOD = 'SET_MASTER_METRICS_PERIOD'
const MUTATION_SET_METRICS_TYPE = 'SET_MASTER_METRICS_TYPE'

export {
  MUTATION_SET_USER,
  MUTATION_SET_IS_AUTHENTICATED,
  MUTATION_SET_USER_TOKEN,
  MUTATION_SET_NOTIFICATION,

  MUTATION_SET_COURSES,
  MUTATION_SET_APPLICATIONS,
  MUTATION_SET_APPROVE,
  MUTATION_SET_REJECT,

  MUTATION_SET_METRICS_PERIOD,
  MUTATION_SET_METRICS_TYPE,
}



// WEBPACK FOOTER //
// ./client/masteradmin/store/mutations.js